import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, forkJoin, of } from 'rxjs';
import { takeUntil, switchMap, catchError } from 'rxjs/operators';
import { NotificationAddEditComponent } from 'src/app/Component/notification-management/notification-add-edit/notification-add-edit.component';
import { NgbdSortableHeader, SortEvent } from 'src/app/directives/sort.directive';
import { IGetCodes } from 'src/app/interfaces/codes';
import { IPracticeTest, ICoursePlanMockExam } from 'src/app/Models/ExamAgencies';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { AddEditMockExamModalComponent } from '../../add-edit-mock-exam-modal/add-edit-mock-exam-modal.component';
import { compare } from '../exam-agencies.component';
import { AddEditWeeklyPracticeTestModalComponent } from '../../add-edit-weekly-practice-test-modal/add-edit-weekly-practice-test-modal.component';

@Component({
  selector: 'app-weeklypracticetest',
  templateUrl: './weeklypracticetest.component.html',
  styleUrls: ['./weeklypracticetest.component.css']
})
export class WeeklypracticetestComponent implements OnInit {
courseId: string = '';
  ExamAgencyName: string = '';
  CourseName: string = '';
  ExamYear: string = '';
  currentRoute: string = '';
  private destroy$ = new Subject<void>(); // Used for unsubscribing
  courses: IGetCodes[];
  weeklyPracticeTest: IPracticeTest[] = [];
  CourseAppliableCourseType: ICoursePlanMockExam[];
  public sortColumn = '';
  public sortDirection: 'asc' | 'desc' | '' = '';
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  unWeeklyPracticeTest: IPracticeTest[];
  selectedRowId: number | null = null;
  availableDateFilter = '';


  constructor(
    private modalService: NgbModal,
    private modalServiceLocal: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    public service: ContentManagementService,
    public toastr: ToastrService,
    private ExamService: ExamManagementService,
    public session: SessionService
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$),
        switchMap((queryParams) => {
          this.courseId = queryParams['c_id'];
          this.ExamAgencyName = queryParams['eA_Name'];
          this.CourseName = queryParams['c_Name'];
          this.ExamYear = queryParams['eY_Name'];
          return forkJoin({
            courseCodes: this.service
              .GetCode({ Tablename: 'COURSE_PLAN_TYPE' })
              .pipe(
                catchError((error) => {
                  console.error('Error fetching course codes:', error);
                  return of([]);
                })
              ),
            coursePlans: this.service
              .getCoursePlan$(
                this.session.getUser(),
                +this.courseId,
                '',
                'ASSIGNMOCKEXAM',
                '',
                ''
              )
              .pipe(
                catchError((error) => {
                  console.error('Error fetching course plans:', error);
                  return of(null);
                })
              ),
            applicableCoursePlans:
              this.ExamService.getWeeklyPracticeTestApplicableCoursePlan({
                ScreenName: null,
                CourseTestID: null,
                CourseID: +this.courseId,
                CoursePlanID: null,
                SelectedInd: null,
              }).pipe(
                catchError((error) => {
                  console.error(
                    'Error fetching applicable course plans:',
                    error
                  );
                  return of(null);
                })
              ),
          });
        })
      )
      .subscribe(({ courseCodes, coursePlans, applicableCoursePlans }) => {
        this.getPracticeTestWeekly();
        this.courses = courseCodes;
        this.CourseAppliableCourseType = applicableCoursePlans;
      });

      this.ExamService.selectedExamId$.pipe(takeUntil(this.destroy$)).subscribe(id => {
        this.selectedRowId = id;
      });
  }

  setSelectedExamId(id: number | null) {
    this.ExamService.setSelectedExamId(id);
  }

  getPracticeTestWeekly() {
    const payload = {
      CourseID: +this.courseId,
      CoursePlanID: null,
      PracticeTestID: null,
      CalledFrom: 'Practice Test Management',
    };
    this.ExamService.getWeeklyPracticeTest(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.unWeeklyPracticeTest = res || [];
          this.applyFilterAndSort();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  checkedCoursePlan(type: string, testId: number): boolean {
    return this.CourseAppliableCourseType.some(
      (e) =>
        e.Course_Plan_Type_Code === type &&
        Number(e.Course_Test_Id) === Number(testId) &&
        e.Deleted_Ind === 'N'
    );
  }
  materialID:any

  AddEditExam(WeeklyPracticeTest?: IPracticeTest) {
    const modalRef = this.modalService.open(AddEditWeeklyPracticeTestModalComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.WeeklyPracticeTest = WeeklyPracticeTest || undefined;
    modalRef.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
        this.materialID = result;
        // Perform actions after modal is closed
        // this.CreateNotification()
        this.ngOnInit(); // Example: Refresh list after closing
      },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

      // async CreateNotification(): Promise<boolean> {
      //   try {
      //     // Step 1: Ask for confirmation
      //     const result = await this.modalServiceLocal.open(
      //       'Confirmation',
      //       'Do you want to send notification to all the users about this Mock Exam?',
      //       'Yes',
      //       'No'
      //     );

      //     if (!result) {
      //       return false; // user cancelled
      //     }

      //     // Step 2: Open notification modal
      //     const modalRef = this.modalService.open(NotificationAddEditComponent, {
      //       centered: true,
      //       size: 'xl',
      //       windowClass: 'custom-modal-width-notification-course',
      //       backdropClass: 'custom-backdrop-notification'
      //     });

      //     // Pass data into modal
      //     modalRef.componentInstance.screenName = 'MockExam';
      //     modalRef.componentInstance.MaterialId =this.materialID

      //     // Step 3: Wait for modal close result
      //     const notificationResult = await modalRef.result
      //       .then((res: any) => res)
      //       .catch(() => false);

      //     return !!notificationResult;
      //   } catch (error) {
      //     console.error('CreateNotification dismissed or failed:', error);
      //     return false;
      //   }
      // }

  getPlanNameInitails(courseName: string) {
    if (courseName.split(' ')[1] === 'Plan') {
      return courseName.split(' ')[0];
    } else {
      return courseName;
    }
  }
  public onSort({ column, direction }: SortEvent) {
    const sortColumn = String(column || '');

    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== sortColumn) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '' || sortColumn === '') {
      this.sortColumn = '';
      this.sortDirection = '';
      this.applyFilterAndSort();
    } else {
      this.sortColumn = sortColumn;
      this.sortDirection = direction;
      this.applyFilterAndSort();
    }
  }

  onAvailableDateFilterChange(value: string): void {
    this.availableDateFilter = value;
    this.applyFilterAndSort();
  }

  clearAvailableDateFilter(): void {
    if (!this.availableDateFilter) {
      return;
    }
    this.availableDateFilter = '';
    this.applyFilterAndSort();
  }

  private applyFilterAndSort(): void {
    let filteredList = [...(this.unWeeklyPracticeTest || [])];

    if (this.availableDateFilter) {
      filteredList = filteredList.filter(
        (item) => this.getDateOnlyString(item.Available_Date) === this.availableDateFilter
      );
    }

    if (this.sortColumn && this.sortDirection) {
      const sortColumn = String(this.sortColumn);
      filteredList = filteredList.sort((a: any, b: any) => {
        const first = this.getSortValue(a, sortColumn);
        const second = this.getSortValue(b, sortColumn);
        const res = compare(first, second);
        return this.sortDirection === 'asc' ? res : -res;
      });
    }

    this.weeklyPracticeTest = filteredList;
  }

  private getSortValue(item: IPracticeTest, column: string): string | number | Date | null {
    if (column === 'Available_Date') {
      const dateValue = this.getDateOnlyString(item.Available_Date);
      return dateValue ? new Date(dateValue).getTime() : null;
    }

    const value = (item as any)[column];
    if (typeof value === 'string') {
      return value.toLowerCase();
    }

    return value ?? null;
  }

  private getDateOnlyString(dateValue: any): string {
    if (!dateValue) {
      return '';
    }

    if (typeof dateValue === 'string') {
      const match = dateValue.trim().match(/^(\d{4}-\d{2}-\d{2})/);
      if (match) {
        return match[1];
      }
    }

    const parsedDate = new Date(dateValue);
    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  navigateToPracticeTestQuestions(item: IPracticeTest) {
    const subjectId = item.Main_Subject_ID  ?? null;
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        p_Seq: item.Practice_Test_Sequence_Number,
        p_Name: item.Practice_Test_Name,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        t_q: item.Number_Of_Questions,
        ...(subjectId ? { subject_id: subjectId } : {}),
      },
      skipLocationChange: false,
    };
    this.router.navigate(
      ['Exam/WeeklyPracticeTestsQuestion', item.Course_Test_Id],
      navigationExtras
    );
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;

    const shouldKeepSelection =
    currentUrl.includes('Exam/MockExams') ||
      currentUrl.includes('Exam/MockExamsQuestion') ||
      currentUrl.includes('Exam/AddEditMockExamsQuestion') ||
      currentUrl.includes('Exam/WeeklyPracticeTestsQuestion');

    if (!shouldKeepSelection) {
      this.setSelectedExamId(null); // Clear the selection
    }
    this.destroy$.next(); // Emit value to trigger unsubscription
    this.destroy$.complete(); // Ensures Subject is fully closed
  }
}
